import { apply_mou_path } from '@routes';

import request from './request';

export interface CancelOfferResponse {
  message?: string;
  redirectUri?: string;
  success: boolean;
}

export async function cancelOffer() {
  const resp = await request('post', apply_mou_path());
  return resp;
}
